import { useState } from 'react';
import PropTypes from 'prop-types';

import {
  FieldMapContainer,
  FieldMapGroup,
  IconFlipWrapper,
  FieldMapItemList,
  FieldMapItem,
  FieldMapItemBtn,
  MapLines,
} from './styled/ManageInstance.styled';

import { ExpandMore } from '../../../juristec-ui/icons';

const FieldMap = ({
  startsOpen = false, groupName, fields,
}) => {
  const [expand, setExpand] = useState(startsOpen);

  const handleExpandClick = () => {
    setExpand((p) => !p);
  };

  return (
    <FieldMapContainer>
      <FieldMapGroup onClick={handleExpandClick}>
        <IconFlipWrapper flip={expand}>
          <ExpandMore />
        </IconFlipWrapper>
        {groupName}
      </FieldMapGroup>
      <FieldMapItemList expand={expand}>
        {fields.map((field) => (
          <FieldMapItem key={`map-item-${field.kWord}`}>
            <MapLines />
            <FieldMapItemBtn onClick={field.scrollToField}>
              {field.label}
            </FieldMapItemBtn>
          </FieldMapItem>
        ))}
      </FieldMapItemList>
    </FieldMapContainer>
  );
};

FieldMap.propTypes = {
  startsOpen: PropTypes.bool,
  groupName: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default FieldMap;
